import {ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {NgIf, NgSwitch, NgSwitchCase} from '@angular/common';
import {MatIconModule} from '@angular/material/icon';

export type IconProvider = 'material' | 'tabler';

const prefixes = {
  tabler: 'tabler:',
  customSvg: 'svg:'
} as const;

type TablerPrefix = `tabler:`;

@Component({
  selector: 'app-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
  standalone: true,
  imports: [NgSwitch, NgSwitchCase, NgIf, MatIconModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconComponent implements OnChanges {
  _name: string;
  _size: string;
  _provider: IconProvider = 'material';
  isMaterialSvgIcon: boolean = false;

  @Input() name: string | `${TablerPrefix}${string}` = '';
  @Input() size: number | string = 16;
  @Input() class?: string;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.name && this.name) {
      this._provider = 'material';
      this.isMaterialSvgIcon = false;
      this._name = this.name;

      if (this.name.startsWith(prefixes.tabler)) {
        this._provider = 'tabler';
        this._name = this.name.replace(prefixes.tabler, '');
      } else if (this.name.startsWith(prefixes.customSvg)) {
        this.isMaterialSvgIcon = true;
        this._name = this.name.replace(prefixes.customSvg, '');
      }
    }

    if (changes.size) {
      const isNumber = !isNaN(+this.size);
      this._size = isNumber ? `${this.size}px` : (this.size as string);
    }
  }
}
